import * as Actions from '../actions/actionTypes';

const initialState = {
    isFetching : false,
    err : false,
    isFetched : false,
    message : ''
  };
  
  // receiving response sent by action according to type of action
  export default function updateFAQ(state = initialState, action) {
      //console.log(action,'action')
    switch (action.type) {
      case Actions.DELETEFAQREQUEST:
        return { 
            isFetching : true,
            err : false,
            isFetched : false,
            message : 'fetching...'
        };
        break;
  
      case Actions.DELETEFAQSUCCESS:
        return { 
            isFetching : false,
            err : false,
            isFetched : true,
            message : action.payload.message
            
          };
          break;
          
          case Actions.DELETEFAQERROR:
          return { 
            isFetching : false,
            err : true,
            isFetched : false,
            message : action.payload.message
         };
        break;
      
      case Actions.DELETEFAQCLEAR:
        return { 
            isFetching : false,
            err : false,
            isFetched : false,
            message : ''
         };
        break;

      default:
        return state;
    }
  }
  